import { render } from "./agent.vue?vue&type=template&id=374d791e&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"

import "./agent.vue?vue&type=style&index=0&id=374d791e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-374d791e"

export default script